<template>
    <BreadCrumb PageTitle="Ajouter une règle de tarification" />
    <AddPricingRule/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddPricingRule from "@/components/RegleTarification/AddPricingRule.vue";
  
    export default defineComponent({
      name: "AddBescPricingRulePage",
      components: {
        BreadCrumb,
        AddPricingRule,
      },
    });
  </script>